import { Navigate } from "react-router-dom";
import { PAGES_ENDPOINTS } from "../config/api";
import { useAuth } from "../contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <p className="p-4 text-center text-gray-600">Verifica sessione...</p>;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={PAGES_ENDPOINTS.LOGIN} replace />;
  }

  if (requireAdmin && !(user.can_manage_all || user.can_manage_content)) {
    return <Navigate to={PAGES_ENDPOINTS.HOME} replace />;
  }

  return <>{children}</>;
}
